import { Domaine } from './domaine.model';
import { OrganismeType } from './organisme-type.model';
import { Pays } from './pays.model';
import { Structure } from './structure.model';
import { DataIdArrayConverterFactory, DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class Organisme {
    static jsonMap = {
        id: { key: 'id', optional: true },
        type: { key: 'idType', converter: new (DataIdConverterFactory.build(OrganismeType, 'typesOrganismes'))(), optional: true },
        structure: { key: 'idStructure', converter: new (DataIdConverterFactory.build(Structure, 'structures'))(), optional: true },
        siret: { key: 'siret', optional: true, default: '' },
        raisonSociale: { key: 'raisonSociale', optional: true, default: '' },
        adresse: { key: 'adresse', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        ville: { key: 'ville', optional: true, default: '' },
        pays: { key: 'idPays', converter: new (DataIdConverterFactory.build(Pays, 'pays'))(), optional: true },
        cedex: { key: 'cedex', optional: true, default: '' },
        telephone: { key: 'telephoneFixe', optional: true, default: '' },
        portable: { key: 'telephoneMobile', optional: true, default: '' },
        fax: { key: 'fax', optional: true, default: '' },
        mail: { key: 'mail', optional: true, default: '' },
        domaines: { key: 'domaines', converter: new (DataIdArrayConverterFactory.build(Domaine, 'domaines'))(), default: () => [] },
        logo: { key: 'logo', optional: true, default: '' }
    };

    public id: number;
    public type: OrganismeType;
    public structure: Structure;
    public siret: string;
    public raisonSociale: string;
    public adresse: string;
    public codePostal: string;
    public ville: string;
    public pays: Pays;
    public cedex: string;
    public telephone: string;
    public portable: string;
    public fax: string;
    public mail: string;
    public domaines: Domaine[] = [];
    logo: string;

    // TODO abbonements
}
